export class EmailBody {
    Message: string;
    Name: string;
    FromEmail: string;
    FromPhone: string;
}
